<script setup lang="ts">
import { Separator, type SeparatorProps } from "reka-ui";
import { twMerge } from "tailwind-merge";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<
	SeparatorProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});
</script>

<template>
	<Separator
		v-bind="delegatedProps"
		:class="twMerge(
			'shrink-0 bg-border',
			props.orientation === 'vertical' ? 'w-px h-full' : 'h-px w-full',
			props.class,
		)"
	/>
</template>
